/**
 * 
 * key
 * 
 */


const key = 'cHJpbnRQbERpc3BhdGNoUGVuZGluZw=='

export default key 